import { loadMorePropertyCards } from "./properties-load";

(function($){
  $(function() {
    const $commFilters = $('#community-filters');
    const $commReset = $('#community-reset');
    const $propertyList = $('#property-list');
    const $propertyLoadMoreButton = $('#property-load-more');
    
    if ($propertyList.length) {
      
      const $initialPropertiesCache = $propertyList.children();

      // let propertyFilterValues = {city: '', state: ''}; 
      const propertyReq = {
        limit: 2,
        offset: 2,
        filterValues: { 
          city: '',
          state: ''
        },
        setNextOffset: function() {
          this.offset += this.limit;
        },
        clearOffset: function() { 
          console.log('clearing offset, old val: ', this.offset);
          this.offset = 0; 
        },
        reset: function() {
          this.offset = 0;
          this.filterValues.city = '';
          this.filterValues.state = '';
        },
        init: function() {
          this.offset = parseInt(window.propertyPostsLimit, 10); // from PHP
          this.limit = parseInt(window.propertyPostsLimit, 10); // from PHP
          this.filterValues.city = '';
          this.filterValues.state = '';
        }
      };

      // let propertyOffset = window.propertyPostsLimit; 
      // propertyReq.offset = parseInt(window.propertyPostsLimit, 10); // from PHP
      // const propertyLimit = window.propertyPostsLimit;
      // propertyReq.limit = parseInt(window.propertyPostsLimit, 10); // from PHP
      
      propertyReq.init();
      
      $commReset.on('click', { propertyReqSettings: propertyReq, propertyList: $propertyList }, function resetFilters(event) {
        $commFilters.find('select').prop('selectedIndex',0).prop('disabled',false).find('option').prop('disabled',false);
        // $propertyList.find('.card').prop('hidden',false).attr('data-status','show');
        // propertyFilterValues = {city: '', state: ''};
        // event.data.propertyReqSettings.reset();
        event.data.propertyReqSettings.init();
        event.data.propertyList.empty();
        if (event.data.propertyReqSettings.offset >= window.totalProperties) {
          // window.totalProperties comes from PHP using wp_count_posts
          $propertyLoadMoreButton.css('display', 'none');
        } else {
          $propertyLoadMoreButton.css('display', 'block');
        }
        // loadMorePropertyCards({ 
        //   data: {
        //     propertyReqSettings: event.data.propertyReqSettings,
        //     propertyList: event.data.propertyList,
        //     loadMoreButton: $propertyLoadMoreButton
        //   } 
        // });
        event.data.propertyList.append($initialPropertiesCache);
      }); // community filters reset
      
      $commFilters.on('change', function filterCommunitiesInView(e) {
        let $this = $(this);
        let $select = $(e.target);
        let filterProp = $select.data('filter');
        console.log('filter prop: ', filterProp);
        let selectedVal = $select.val();
        // propertyFilterValues[filterProp] = selectedVal;
        propertyReq.filterValues[filterProp] = selectedVal;
        console.log('filter val: ', selectedVal);
        if (selectedVal == 0) {
          $commReset.trigger('click');
          // propertyFilterValues = {city: '', state: ''};
          // window.propertyReq.filterValues.city = '';
          // window.propertyReq.filterValues.state = '';
          // propertyReq.reset();
          return;
        }
        if (filterProp === 'city') {
          $this.find('select[data-filter="state"]').prop('disabled',true);
        } else {
          $this.find('select[data-filter="city"]').find('option').not(`[data-state="${selectedVal}"]`).prop('disabled',true);
        }
        // $propertyList.find('.card').not(`[data-${filterProp}="${selectedVal}"]`).prop('hidden',true).attr('data-status','hide');
        // $propertyList.find(`.card[data-${filterProp}="${selectedVal}"]`).prop('hidden',false).attr('data-status','show');
        propertyReq.clearOffset();
        console.log('propertyReq: ', propertyReq);
        $propertyList.empty();
        loadMorePropertyCards({ 
          data: {
            propertyReqSettings: propertyReq,
            propertyList: $propertyList,
            loadMoreButton: $propertyLoadMoreButton
          } 
        });

        // Scroll to cards
        /*
        let dest = 0;
        if ($propertyList.offset().top > $(document).height() - $(window).height()) {
            dest = $(document).height() - $(window).height();
        } else {
            dest = $propertyList.offset().top;
        }
        //go to destination
        $('html,body').animate({
            scrollTop: dest
        }, 500, 'swing');
        */

      }); // community filters

      $('#property-load-more').on(
        'click', 
        { 
          propertyReqSettings: propertyReq, 
          propertyList: $propertyList, 
          loadMoreButton: $propertyLoadMoreButton  
        }, 
        loadMorePropertyCards); // load more click handler

    } // properties exists check
    
  });
})(jQuery);